import type { Ref } from 'react';
import type { InputHTMLAttributes, ReactNode } from 'react';
import { cx } from '../lib/cx';

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  round?: boolean;
  multiline?: boolean;
  children?: ReactNode;
}

const CHECK_PATH = 'M3 7l3 3 5-6';

export function Checkbox(
  { ref, round = false, multiline = false, className, children, ...rest }: CheckboxProps & { ref?: Ref<HTMLInputElement> },
) {
  return (
    <label className={cx('checkbox-row', multiline && 'is-multiline', className)}>
      <input type="checkbox" ref={ref} {...rest} />
      <span className={cx('checkbox', round && 'is-round')}>
        <svg viewBox="0 0 14 14">
          <path d={CHECK_PATH} />
        </svg>
      </span>
      {children != null && <span className="checkbox-label">{children}</span>}
    </label>
  );
}
